/* unplugin-vue-components disabled */import script from "./IntroduceInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./IntroduceInfo.vue?vue&type=script&setup=true&lang=js"

import "./IntroduceInfo.vue?vue&type=style&index=0&id=a7075160&lang=css"

const __exports__ = script;

export default __exports__